import { impersonationApi } from '@repo/api'
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useImpersonationStore } from '@/store/impersonation-store'

export const useActiveImpersonation = () => {
  const sessionId = useImpersonationStore((s) => s.sessionId)
  const setSession = useImpersonationStore((s) => s.setSession)
  const clear = useImpersonationStore((s) => s.clear)

  const query = useQuery({
    queryKey: ['impersonation', 'active', sessionId],
    queryFn: () => impersonationApi.getActive(),
    enabled: !!sessionId,
    retry: false,
    staleTime: 60_000,
  })

  useEffect(() => {
    if (query.data) {
      setSession(query.data)
    }
  }, [query.data, setSession])

  useEffect(() => {
    if (query.isError) {
      clear()
    }
  }, [query.isError, clear])

  return query
}
